import script from "./AttentionOrderDeleteModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttentionOrderDeleteModal.vue?vue&type=script&lang=ts&setup=true"

import "./AttentionOrderDeleteModal.vue?vue&type=style&index=0&id=54d5339b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d5339b"]])

export default __exports__